'use client';

import { FrontendOrganizationInvite, UUID } from '@trucksmarter/shared';
import Endpoint from '../../../../../_lib/api/endpoints';
import useFetchResource from '../../../../../_lib/api/client/resources/useFetchResource';

export default function useFetchOrganizationInviteDetails(inviteId: string) {
  const {
    data,
    mutate: _,
    ...requestState
  } = useFetchResource<{ inviteId: UUID }, FrontendOrganizationInvite>(
    Endpoint.OrganizationInviteDetails,
    { inviteId: inviteId as UUID },
  );

  return {
    data,
    ...requestState,
  };
}
